import * as React from "react";
import { FC } from "react";
import { useIntl } from "react-intl";
import Places from "../../../data/placeOfOrigin.json";
import { GetTranslation } from "../../../translations/GetTranslation";
import { CustomAutocomplete } from "./CustomAutocomplete";
import { IBaseSelectProps } from "./IBaseSelectProps";

export interface IPlaceOfOriginOption {
  value: string;
  canton: string;
}

interface IPlaceOfOriginSelectProps extends IBaseSelectProps<string, IPlaceOfOriginOption | null> {
  name?: string;
  defaultValue?: string;
}

const options: IPlaceOfOriginOption[] = Places.map((place) => ({
  value: place.value,
  canton: place.canton,
}));

export const PlaceOfOriginSelect: FC<IPlaceOfOriginSelectProps> = ({
  defaultValue,
  value,
  onChange = (_value: IPlaceOfOriginOption | null) => {},
  onBlur,
  ...props
}) => {
  const intl = useIntl();
  const defaultOption =
    defaultValue === undefined ? undefined : options.find((option) => option.value === defaultValue) || null;
  const selectedOption = value === undefined ? undefined : options.find((option) => option.value === value) || null;
  return (
    <CustomAutocomplete
      {...props}
      label={GetTranslation(intl, "candidate.field.placeOfOrigin")}
      options={options}
      getOptionLabel={(option) => option.value}
      defaultValue={defaultOption}
      value={selectedOption}
      onChange={(_event, value) => onChange(value)}
      onBlur={onBlur}
    />
  );
};
